import type { ReactElement } from 'react';

// The landing. The home dashboard (DashboardView) is rendered by the keep-alive
// DashboardHost in AppFrame under the `home` key — mounted once and revealed
// instantly on return — so this route surface renders nothing itself.
export function Home(): ReactElement | null {
  return null;
}
